import { Box, Stack, styled, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import defaultLogo from '../../Assets/vantris-energy-logo-1x.png';
import darkLogo from "../../Assets/Logo-WWS-Energies-blanc.png";

import { useAuth } from "../../Context/AuthContext.jsx";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function DrawerHeader({ open, toggle }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { user } = useAuth();

  return (
    <Header>
      <div className="w-full">
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          sx={{ my: 2, mb: 3, position: 'relative' }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              position: "relative"
            }}
          >
            {/* Logo */}
            <img
              src={theme.palette.mode ==='dark'?defaultLogo:defaultLogo}
              className="logo"
              style={{
                width: open ? 160 : 58,
                height: open ? 60 : 38,
                transition: "all 0.3s",
                transform: "none",
                objectFit: "contain",
              }}
              alt="Company Logo"
            />
              
            {/* Toggle icon adjacent to logo when sidebar is closed */}
            {!open && (
              <Tooltip title="Open sidebar">
                <IconButton
                  onClick={toggle}
                  size="small"
                  sx={{
                    padding: "2px",
                    marginLeft: "-16px",
                    '&:hover': {
                      backgroundColor: "transparent",
                      '& .MuiSvgIcon-root': {
                        color: colors.primary[400],
                      }
                    },
                  }}
                >
                  <ChevronRightIcon
                    sx={{
                      fontSize: "20px",
                      color: colors.grey[700],
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
            
            {/* Only show collapse chevron when sidebar is open */}
            {open && (
              <Tooltip title="Close sidebar">
              <IconButton
                onClick={toggle}
                sx={{
                  position: 'absolute',
                  right: -40,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: colors.grey[700],
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: colors.primary[400],
                  },
                }}
              >
                <ChevronLeftIcon />
              </IconButton>
              </Tooltip>
                    )}
          </div>
        </Stack>
      </div>
    </Header>
  );
}
